import React from 'react';
import { Link } from 'react-router-dom';
import { Toaster } from '../ui/sonner';

const AuthLayout = ({ children }) => {
  const currentYear = new Date().getFullYear();
  
  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-1 flex">
        {/* Left side - Image */}
        <div 
          className="hidden lg:flex lg:w-1/2 relative"
          style={{
            backgroundImage: `url('/assets/ptc-background.png')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        >
          <div className="absolute inset-0 bg-slate-900/70" />
          <div className="relative z-10 flex flex-col justify-center p-12">
            <h1 className="font-outfit text-4xl font-bold text-white mb-4">
              PTC Builder
            </h1>
            <p className="text-slate-200 text-lg max-w-md leading-relaxed">
              Streamline your parent-teacher conference creation in Veracross with our comprehensive management platform.
            </p>
          </div>
        </div>

        {/* Right side - Form */}
        <div className="flex-1 flex items-center justify-center p-8 bg-slate-50">
          <div className="w-full max-w-md">
            {children}
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-slate-100 border-t border-slate-200 py-4 px-8">
        <p className="text-center text-sm text-slate-500">
          © {currentYear} Borrow A Geek Limited Trading as EDUx. All Rights Reserved. | <Link to="/changelog" className="text-indigo-600 hover:text-indigo-700 hover:underline" data-testid="version-link">Version 1.4</Link>
        </p>
      </footer>

      <Toaster position="top-right" />
    </div>
  );
};

export default AuthLayout;
